"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommWebService = void 0;
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2020 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
const enums_1 = require("../enums");
const config_1 = require("./config");
const util_1 = require("./util");
class CommWebService {
    /**
     * Constructor
     *
     * This will configure and setup the CommWebService.
     *
     * apiConfig is used for consuming the main api.
     *
     * @param ApiConfig apiConfig
     */
    constructor(apiConfig, authenticationService) {
        this.apiConfig = apiConfig;
        this.authenticationService = authenticationService;
        (0, config_1.setUseMock)(this.apiConfig.useMockData);
    }
    useAuthenticationService(authenticationService) {
        this.authenticationService = authenticationService;
    }
    /**
     * Generic method for consuming APIs written by Commercial Web.
     * Handles session expiry if "authenticationService" is provided.
     * @param ApiRequest apiRequest
    */
    sendRequest(apiRequest) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const isReauthenticated = !!apiRequest.isReauthenticated;
            delete apiRequest.isReauthenticated;
            const config = (0, util_1.buildRequestData)(this.apiConfig, apiRequest);
            if (!config) {
                throw (0, util_1.getUnknownError)('AxiosRequestConfig is null, error in building request data');
            }
            // Authorize the API request if already authenticated.
            if (yield ((_a = this.authenticationService) === null || _a === void 0 ? void 0 : _a.isAuthenticated())) {
                if (!config.headers) {
                    config.headers = {};
                }
                config.headers.Authorization = 'Bearer ' + (yield ((_b = this.authenticationService) === null || _b === void 0 ? void 0 : _b.getAccessToken()));
            }
            // Make the API request.
            try {
                const response = yield (0, config_1.axios)(config);
                return response;
            }
            catch (error) {
                // Handle session expiry.
                if (this.authenticationService && !isReauthenticated) {
                    const sessionExpiryErrorCodes = [
                        enums_1.HttpErrorCode.COMM_SERVICES_TOKEN_EXPIRED,
                        enums_1.HttpErrorCode.LEDS_TOKEN_EXPIRED
                    ];
                    if (sessionExpiryErrorCodes.includes((_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.status)) {
                        // Attempt to renew session, if that fails logout. If it succeeds, run the request again.
                        try {
                            yield this.authenticationService.refreshSession();
                        }
                        catch (reauthenticateError) {
                            yield this.authenticationService.logout();
                            throw error;
                        }
                        apiRequest.isReauthenticated = true;
                        return this.sendRequest(apiRequest);
                    }
                }
                throw error;
            }
        });
    }
    /**
     * Gets the Enhanced Authentication Token (JWT)
     * for consuming the commercial-services.
     *
     * @param commServicesAuthConfig: CommServicesAuthConfig
     */
    getCommServicesEnhancedToken(commServicesAuthConfig) {
        return new Promise((resolve, reject) => {
            const authRequest = {
                method: enums_1.HttpMethod.GET,
                url: commServicesAuthConfig.authenticationUrl
            };
            this.sendRequest(authRequest).then((authResponse) => {
                if (authResponse && authResponse.data && authResponse.data.token) {
                    // now call the enhanced authentication
                    const headers = { Authorization: 'Bearer ' + authResponse.data.token };
                    // add the X-Region header if present
                    // host region is not present in QA and Production
                    // so no need to add it to the header if not present
                    if (commServicesAuthConfig.hostRegion
                        && commServicesAuthConfig.hostRegion.trim().length > 0) {
                        headers['X-Region'] = commServicesAuthConfig.hostRegion;
                    }
                    const enhancedAuthRequest = {
                        method: enums_1.HttpMethod.GET,
                        url: commServicesAuthConfig.memberContextUrl,
                        customHeaders: headers,
                        params: commServicesAuthConfig.enhancedAuthenticationParams
                    };
                    this.sendRequest(enhancedAuthRequest).then((response) => {
                        if (response && response.data) {
                            resolve(response);
                        }
                        else {
                            reject((0, util_1.getUnknownError)('Error in getting Commercial Services Enhanced JWT'));
                        }
                    }).catch((error) => {
                        reject(error);
                    });
                }
                else {
                    reject((0, util_1.getUnknownError)('Error in getting Commercial Services JWT'));
                }
            }).catch((authError) => {
                reject(authError);
            });
        });
    }
}
exports.CommWebService = CommWebService;
//# sourceMappingURL=commweb-service.js.map